/**
 * Pilatix Blog — Custom Scripts
 * File: blog-custom.js
 * Load via: {{ 'blog-custom.js' | asset_url | script_tag }}
 * Dependencies: None (vanilla JS, no frameworks)
 */
(function() {
  'use strict';

  /* ───── Search Toggle + Inline Blog Filter ───── */
  function initSearch() {
    var searchBtn = document.getElementById('pilatix-search-btn');
    var searchBar = document.getElementById('pilatix-search-bar');
    var searchInput = document.getElementById('pilatix-search-input');
    var searchForm = searchBar && searchBar.querySelector('.pilatix-search-form');

    if (!searchBtn || !searchBar) return;

    searchBtn.addEventListener('click', function() {
      var isOpen = searchBar.classList.contains('is-open');
      if (isOpen) {
        searchBar.classList.remove('is-open');
        searchBar.setAttribute('aria-hidden', 'true');
        searchBtn.setAttribute('aria-expanded', 'false');
      } else {
        searchBar.classList.add('is-open');
        searchBar.setAttribute('aria-hidden', 'false');
        searchBtn.setAttribute('aria-expanded', 'true');
        if (searchInput) {
          setTimeout(function() { searchInput.focus(); }, 350);
        }
      }
    });

    /* ───── Live client-side filter ───── */
    var grid = document.getElementById('pilatix-articles-grid');
    var featured = document.querySelector('.pilatix-featured-section');
    var empty = document.getElementById('pilatix-empty');
    var gridLabel = document.querySelector('.pilatix-grid-label');
    var srStatus = document.getElementById('pltx-sr-status');

    /* Screen-reader announcement when search results change */
    function announceResults(count, query) {
      if (!srStatus) return;
      if (!query) { srStatus.textContent = ''; return; }
      srStatus.textContent = count === 0
        ? pltxT('pltx2.js.k043', 'לא נמצאו מאמרים עבור ') + query
        : count + pltxT('pltx2.js.k002', ' מאמרים נמצאו עבור ') + query;
    }

    function normalize(s) {
      return (s || '').toLowerCase().normalize('NFKD').replace(/[\u0591-\u05C7]/g, '').trim();
    }

    /* Animate a card in (was hidden → now visible).
       If it's already visible & not mid-fadeout, do nothing (no re-trigger flicker). */
    function animateCardIn(el) {
      if (!el) return;
      var isOut = el.classList.contains('is-filter-out') || el.classList.contains('is-filter-hidden');
      var isMatched = el.classList.contains('is-filter-match');
      /* Already visible and stable → leave alone */
      if (!isOut && isMatched) return;
      if (!isOut && !el.classList.contains('is-filter-match') && !el.classList.contains('is-filter-hidden') && !el.classList.contains('is-filter-out')) {
        /* Card is in its natural state (just loaded, no filter touched yet) — leave alone */
        return;
      }
      el.classList.remove('is-filter-hidden');
      el.classList.remove('is-filter-out');
      el.classList.remove('is-filter-match');
      /* Force reflow to restart animation */
      void el.offsetWidth;
      el.classList.add('is-filter-match');
    }

    /* Animate a card out (visible → should disappear).
       No-op if already hidden or mid-fadeout. */
    function animateCardOut(el) {
      if (!el) return;
      if (el.classList.contains('is-filter-hidden')) return;
      if (el.classList.contains('is-filter-out')) return; /* already animating out */
      el.classList.remove('is-filter-match');
      el.classList.add('is-filter-out');
      var onEnd = function(e) {
        if (e && e.animationName !== 'pltx-filter-out') return;
        el.removeEventListener('animationend', onEnd);
        el.classList.add('is-filter-hidden');
        el.classList.remove('is-filter-out');
      };
      el.addEventListener('animationend', onEnd);
      setTimeout(function() {
        if (el.classList.contains('is-filter-out')) {
          el.classList.add('is-filter-hidden');
          el.classList.remove('is-filter-out');
        }
      }, 320);
    }

    function filter(query) {
      var q = normalize(query);
      if (!grid) return;

      var featuredCard = featured ? featured.querySelector('.pilatix-card--featured') : null;

      if (!q) {
        /* Reset — animate everything back in */
        if (featured) animateCardIn(featured);
        if (featuredCard) animateCardIn(featuredCard);
        if (gridLabel) gridLabel.style.display = '';
        if (empty) {
          empty.setAttribute('hidden', '');
          empty.hidden = true;
        }
        [].forEach.call(grid.querySelectorAll('.pilatix-card'), function(c) {
          animateCardIn(c);
        });
        return;
      }

      /* Keep the grid label hidden during filtering */
      if (gridLabel) gridLabel.style.display = 'none';

      var matches = 0;

      /* Check the featured card first */
      if (featuredCard) {
        var ftTitle = featuredCard.querySelector('.pilatix-card__title--featured, .pilatix-card__title');
        var ftExcerpt = featuredCard.querySelector('.pilatix-card__excerpt');
        var ftHay = normalize((ftTitle ? ftTitle.textContent : '') + ' ' + (ftExcerpt ? ftExcerpt.textContent : ''));
        if (ftHay.indexOf(q) !== -1) {
          if (featured) animateCardIn(featured);
          animateCardIn(featuredCard);
          matches++;
        } else {
          if (featured) animateCardOut(featured);
          animateCardOut(featuredCard);
        }
      }

      /* Then grid cards */
      [].forEach.call(grid.querySelectorAll('.pilatix-card'), function(card) {
        var title = card.querySelector('.pilatix-card__title, .pilatix-card__title--featured');
        var excerpt = card.querySelector('.pilatix-card__excerpt');
        var hay = normalize((title ? title.textContent : '') + ' ' + (excerpt ? excerpt.textContent : ''));
        if (hay.indexOf(q) !== -1) {
          animateCardIn(card);
          matches++;
        } else {
          animateCardOut(card);
        }
      });

      /* Toggle empty state */
      if (empty) {
        if (matches > 0) {
          empty.setAttribute('hidden', '');
          empty.hidden = true;
        } else {
          empty.removeAttribute('hidden');
          empty.hidden = false;
        }
      }

      /* Announce results to screen readers */
      announceResults(matches, query);
    }

    if (searchInput) {
      var debounce;
      searchInput.addEventListener('input', function() {
        clearTimeout(debounce);
        var val = searchInput.value;
        debounce = setTimeout(function() { filter(val); }, 120);
      });
    }

    /* Prevent native form redirect — filtering is live */
    if (searchForm) {
      searchForm.addEventListener('submit', function(e) {
        e.preventDefault();
        if (searchInput) filter(searchInput.value);
      });
    }

    /* Close search on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchBar.classList.contains('is-open')) {
        if (searchInput && searchInput.value) {
          searchInput.value = '';
          filter('');
        } else {
          searchBar.classList.remove('is-open');
          searchBar.setAttribute('aria-hidden', 'true');
          searchBtn.setAttribute('aria-expanded', 'false');
          searchBtn.focus();
        }
      }
    });
  }

  /* ───── Load More ───── */
  function initLoadMore() {
    var loadMoreBtn = document.getElementById('pilatix-load-more-btn');
    var grid = document.getElementById('pilatix-articles-grid');

    if (!loadMoreBtn || !grid) return;

    loadMoreBtn.addEventListener('click', function() {
      var nextUrl = loadMoreBtn.getAttribute('data-next-url');
      if (!nextUrl) return;

      loadMoreBtn.classList.add('pilatix-load-more--loading');

      var xhr = new XMLHttpRequest();
      xhr.open('GET', nextUrl, true);
      xhr.responseType = 'document';

      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 400) {
          var doc = xhr.response;

          /* Extract new article cards from the response */
          var newGrid = doc.getElementById('pilatix-articles-grid');
          if (newGrid) {
            var newCards = newGrid.children;
            var fragment = document.createDocumentFragment();
            while (newCards.length > 0) {
              fragment.appendChild(newCards[0]);
            }
            grid.appendChild(fragment);
          }

          /* Update or remove the Load More button */
          var newLoadMoreBtn = doc.getElementById('pilatix-load-more-btn');
          if (newLoadMoreBtn) {
            var newNextUrl = newLoadMoreBtn.getAttribute('data-next-url');
            loadMoreBtn.setAttribute('data-next-url', newNextUrl);
          } else {
            /* No more pages — hide the button */
            var wrap = document.getElementById('pilatix-load-more-wrap');
            if (wrap) wrap.style.display = 'none';
          }
        } else {
          /* On error, fall back to normal navigation */
          window.location.href = nextUrl;
        }

        loadMoreBtn.classList.remove('pilatix-load-more--loading');
      };

      xhr.onerror = function() {
        /* On network error, fall back to normal navigation */
        window.location.href = nextUrl;
      };

      xhr.send();
    });
  }

  /* ───── Active Tab Scroll ───── */
  function initActiveTabScroll() {
    var activeTab = document.querySelector('.pilatix-tab__link--active');
    if (!activeTab) return;

    var scrollContainer = activeTab.closest('.pilatix-tabs-scroll');
    if (!scrollContainer) return;

    var tabRect = activeTab.getBoundingClientRect();
    var containerRect = scrollContainer.getBoundingClientRect();
    var scrollLeft = activeTab.offsetLeft - (containerRect.width / 2) + (tabRect.width / 2);
    scrollContainer.scrollLeft = scrollLeft;
  }

  /* ───── Tabs: desktop drag/wheel scrolling + overflow edge fades ─────
     The scrollbar is hidden by design, so without this a mouse user cannot
     reach categories that overflow the row (touch users could always swipe). */
  function initTabsScroll() {
    var scroller = document.querySelector('.pilatix-tabs-scroll');
    if (!scroller) return;
    var wrap = scroller.closest('.pilatix-tabs-wrap');

    function updateFades() {
      if (!wrap) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      if (max <= 1) {
        wrap.classList.remove('has-overflow-start', 'has-overflow-end');
        return;
      }
      // RTL: scrollLeft runs 0 → -max in modern browsers
      var pos = Math.abs(scroller.scrollLeft);
      wrap.classList.toggle('has-overflow-end', pos < max - 1);
      wrap.classList.toggle('has-overflow-start', pos > 1);
    }

    // vertical wheel over the tabs scrolls them horizontally
    scroller.addEventListener('wheel', function(e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return; // native horizontal wheel works already
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      e.preventDefault();
      var dir = document.documentElement.dir === 'rtl' ? -1 : 1;
      scroller.scrollLeft += e.deltaY * dir;
    }, { passive: false });

    // click-and-drag with a mouse
    var dragging = false, startX = 0, startScroll = 0, moved = false;
    scroller.addEventListener('mousedown', function(e) {
      if (scroller.scrollWidth <= scroller.clientWidth) return;
      dragging = true; moved = false;
      startX = e.pageX; startScroll = scroller.scrollLeft;
      scroller.classList.add('is-dragging');
    });
    document.addEventListener('mousemove', function(e) {
      if (!dragging) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 4) moved = true;
      scroller.scrollLeft = startScroll - dx;
    });
    document.addEventListener('mouseup', function() {
      if (!dragging) return;
      dragging = false;
      scroller.classList.remove('is-dragging');
    });
    // a drag must not trigger the tab link click
    scroller.addEventListener('click', function(e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    scroller.addEventListener('scroll', updateFades, { passive: true });
    window.addEventListener('resize', updateFades, { passive: true });
    updateFades();
  }

  /* ───── Reading Progress Bar ───── */
  function initProgress() {
    var bar = document.getElementById('pilatix-progress');
    if (!bar) return;
    var body = document.getElementById('pilatix-article-body');
    if (!body) return;

    var ticking = false;
    function updateProgress() {
      var bodyRect = body.getBoundingClientRect();
      var bodyTop = bodyRect.top + window.pageYOffset;
      var bodyHeight = body.offsetHeight;
      var viewportHeight = window.innerHeight;
      var scrolled = window.pageYOffset - bodyTop + viewportHeight;
      var total = bodyHeight + viewportHeight;
      var pct = Math.max(0, Math.min(100, (scrolled / total) * 100));
      bar.style.width = pct + '%';
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateProgress);
        ticking = true;
      }
    }, { passive: true });

    updateProgress();
  }

  /* ───── Copy Link (class-based — supports multiple share bars per page) ───── */
  function initCopyLink() {
    var btns = document.querySelectorAll('.pilatix-share-btn--copy');
    if (!btns.length) return;

    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); done(); } catch(e) {}
      document.body.removeChild(ta);
    }

    [].forEach.call(btns, function(btn) {
      var tooltip = btn.querySelector('.pilatix-copy-tooltip');

      function showCopied() {
        btn.classList.add('is-copied');
        if (tooltip) tooltip.classList.add('is-visible');
        setTimeout(function() {
          btn.classList.remove('is-copied');
          if (tooltip) tooltip.classList.remove('is-visible');
        }, 2000);
      }

      btn.addEventListener('click', function() {
        var url = window.location.href;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showCopied).catch(function() {
            fallbackCopy(url, showCopied);
          });
        } else {
          fallbackCopy(url, showCopied);
        }
      });
    });
  }

  /* ───── Table of Contents (Pilatix-style Show More) ───── */
  function initToc() {
    var tocContainer = document.getElementById('pilatix-toc');
    var tocList = document.getElementById('pilatix-toc-list');
    var tocMore = document.getElementById('pilatix-toc-more');
    var articleBody = document.getElementById('pilatix-article-body');
    if (!tocContainer || !tocList || !articleBody) return;

    var headings = articleBody.querySelectorAll('h2');
    if (headings.length === 0) {
      tocContainer.style.display = 'none';
      return;
    }

    var VISIBLE_COUNT = 4;

    headings.forEach(function(heading, index) {
      var id = 'section-' + (index + 1);
      heading.setAttribute('id', id);

      var li = document.createElement('li');
      li.className = 'pilatix-toc__item';
      var a = document.createElement('a');
      a.className = 'pilatix-toc__link';
      a.href = '#' + id;
      a.textContent = heading.textContent;
      a.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.replaceState(null, '', '#' + id);
        }
      });
      li.appendChild(a);
      tocList.appendChild(li);
    });

    /* Only show the "Show More" button if we have more than the visible threshold */
    if (tocMore && headings.length > VISIBLE_COUNT) {
      tocMore.hidden = false;
      var label = tocMore.querySelector('.pilatix-toc__more-label');

      tocMore.addEventListener('click', function() {
        var isExpanded = tocContainer.classList.toggle('is-expanded');
        tocMore.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        if (label) label.textContent = isExpanded ? pltxT('pltx2.js.k030', 'הצגת פחות') : pltxT('pltx2.js.k029', 'הצגת הכל');
      });
    }
  }

  /* ───── FAQ Accordion ───── */
  function initFaq() {
    var faqSection = document.getElementById('pilatix-faq');
    if (!faqSection) return;

    var questions = faqSection.querySelectorAll('.pilatix-faq__question');
    questions.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.closest('.pilatix-faq__item');
        var isOpen = item.classList.contains('is-open');

        /* Close all siblings */
        var siblings = faqSection.querySelectorAll('.pilatix-faq__item');
        siblings.forEach(function(s) {
          s.classList.remove('is-open');
          s.querySelector('.pilatix-faq__question').setAttribute('aria-expanded', 'false');
        });

        /* Toggle current */
        if (!isOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ───── Lazy Image Fade-in ─────
     The fade class (.pltx-lazy-fade → opacity 0) is added HERE, by JS,
     not in the server HTML/CSS — so if this script ever fails to run,
     images simply render normally (progressive enhancement). */
  function initLazyImages() {
    var images = document.querySelectorAll('.pilatix-article-body img');
    if (!images.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            var img = entry.target;
            if (img.complete) {
              img.classList.add('is-loaded');
            } else {
              img.addEventListener('load', function() {
                img.classList.add('is-loaded');
              });
              /* Broken image must not stay an invisible white box */
              img.addEventListener('error', function() {
                img.classList.add('is-loaded');
              });
            }
            observer.unobserve(img);
          }
        });
      }, { rootMargin: '200px 0px' });

      images.forEach(function(img) {
        if (img.complete) return; /* already rendered — skip the fade */
        img.classList.add('pltx-lazy-fade');
        observer.observe(img);
      });
    }
    /* No IntersectionObserver → no fade class was added → images just show */
  }

  /* ───── Add Lazy Loading to Content Images ───── */
  function initContentLazyLoading() {
    var body = document.getElementById('pilatix-article-body');
    if (!body) return;
    var imgs = body.querySelectorAll('img:not([loading])');
    imgs.forEach(function(img) {
      img.setAttribute('loading', 'lazy');
    });
  }

  /* ───── In-content FAQ Accordion (progressive enhancement) ─────
     API-created articles end with an h2 titled pltxT("pltx2.js.k081", "שאלות נפוצות") followed by
     h3 question / content answer pairs. Wrap each pair into an accessible
     accordion item. Degrades gracefully: without JS the plain h3/p flow
     renders as-is. */
  function initContentFaq() {
    var body = document.getElementById('pilatix-article-body');
    if (!body) return;

    var faqH2 = null;
    [].forEach.call(body.querySelectorAll('h2'), function(h) {
      if (!faqH2 && h.textContent.indexOf(pltxT('pltx2.js.k081', 'שאלות נפוצות')) !== -1) faqH2 = h;
    });
    if (!faqH2) return;

    /* Collect all nodes after the FAQ h2 until the next h2, a <details>
       block (pipeline-appended .pltx-sources / .pltx-disclaimer must NOT
       be swallowed into the last answer), or end */
    var nodes = [];
    var n = faqH2.nextSibling;
    while (n) {
      if (n.nodeType === 1 && (n.tagName === 'H2' || n.tagName === 'DETAILS')) break;
      nodes.push(n);
      n = n.nextSibling;
    }

    /* Group into question (h3) / answer (everything until next h3) pairs */
    var items = [];
    var cur = null;
    nodes.forEach(function(node) {
      if (node.nodeType === 1 && node.tagName === 'H3') {
        cur = { q: node, a: [] };
        items.push(cur);
      } else if (cur) {
        cur.a.push(node);
      }
    });
    if (!items.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'pilatix-cfaq';

    items.forEach(function(it, i) {
      var item = document.createElement('div');
      item.className = 'pilatix-cfaq__item' + (i === 0 ? ' is-open' : '');

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'pilatix-cfaq__btn';
      btn.id = 'pltx-cfaq-q-' + (i + 1);
      btn.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');
      btn.setAttribute('aria-controls', 'pltx-cfaq-a-' + (i + 1));

      var qspan = document.createElement('span');
      qspan.className = 'pilatix-cfaq__q';
      qspan.innerHTML = it.q.innerHTML;
      btn.appendChild(qspan);

      var icon = document.createElement('span');
      icon.className = 'pilatix-cfaq__icon';
      icon.setAttribute('aria-hidden', 'true');
      btn.appendChild(icon);

      /* Keep heading semantics: reuse the original h3 as the button wrapper */
      var h = it.q;
      h.className = (h.className ? h.className + ' ' : '') + 'pilatix-cfaq__h';
      h.innerHTML = '';
      h.appendChild(btn);

      var ans = document.createElement('div');
      ans.className = 'pilatix-cfaq__a';
      ans.id = 'pltx-cfaq-a-' + (i + 1);
      ans.setAttribute('role', 'region');
      ans.setAttribute('aria-labelledby', btn.id);

      var inner = document.createElement('div');
      inner.className = 'pilatix-cfaq__a-inner';
      it.a.forEach(function(node) { inner.appendChild(node); });
      ans.appendChild(inner);

      item.appendChild(h);
      item.appendChild(ans);
      wrap.appendChild(item);
    });

    faqH2.parentNode.insertBefore(wrap, faqH2.nextSibling);

    /* Single delegated listener for all questions */
    wrap.addEventListener('click', function(e) {
      var btn = e.target.closest ? e.target.closest('.pilatix-cfaq__btn') : null;
      if (!btn) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      var item = btn.closest('.pilatix-cfaq__item');
      if (item) item.classList.toggle('is-open', !expanded);
    });
  }

  /* ───── Initialize only the modules whose targets exist on this page ───── */
  /* Saves ~5–10 no-op DOM queries per page load */
  var has = function(sel) { return !!document.querySelector(sel); };

  /* Blog listing only */
  if (has('#pilatix-search-btn')) initSearch();
  if (has('#pilatix-load-more-btn')) initLoadMore();
  if (has('.pilatix-tab__link--active')) initActiveTabScroll();
  if (has('.pilatix-tabs-scroll')) initTabsScroll();

  /* Article page only */
  if (has('#pilatix-progress')) initProgress();
  if (has('.pilatix-share-btn--copy')) initCopyLink();
  if (has('#pilatix-toc')) initToc();
  if (has('#pilatix-faq')) initFaq();

  /* Article body exists on article pages */
  if (has('#pilatix-article-body')) {
    initContentFaq();
    /* ORDER MATTERS: add loading="lazy" BEFORE wiring the fade-in observer.
       The previous order (observer first) meant content images gained the
       loading attribute after the observer query ran — with the old CSS
       `img[loading="lazy"] { opacity: 0 }` they stayed invisible forever,
       leaving giant blank white boxes in/after the article. */
    initContentLazyLoading();
    initLazyImages();
  }

})();
